import { newFormatThousandSeparator } from 'utils/formatNumber'
import { isCoordinatorGroup, getCoordinatorMetricValue } from 'utility/Utils'
import MetricCard from './MetricCard'
import { getHoursDescriptions, getStandardHours, isIndicationOnlyGroup } from './metricDescriptions'

const SupplierMetrics = ({ supplier }) => {
  const isCoordinator = isCoordinatorGroup(supplier)
  const isIndicationOnly = isCoordinator || isIndicationOnlyGroup(supplier)
  const metricDescriptions = getHoursDescriptions(getStandardHours(supplier), isIndicationOnly)

  const formatMetricVal = (val) => {
    if (val === null || val === undefined || val === '') return null
    return typeof val === 'number' ? newFormatThousandSeparator(val, 2) : val
  }

  const contractVal = formatMetricVal(supplier.onboarding?.contract)
  const insuranceVal = formatMetricVal(supplier.onboarding?.insurance)
  const minAgeVal = formatMetricVal(supplier.onboarding?.minimumAge)
  const workHoursVal = formatMetricVal(supplier.wage?.workHours)
  const wageAboveMinVal = formatMetricVal(supplier.wage?.wageAboveMinimum)
  const paymentLogsVal = formatMetricVal(supplier.wage?.paymentLogs)
  const productivityVal = formatMetricVal(supplier.wage?.productivity)

  return (
    <div className="mb-3">
      <div
        className="d-flex gap-2"
        style={{
          overflowX: 'auto',
          paddingBottom: '4px',
        }}
      >
        {/* ONBOARD SECTION */}
        <div
          className="d-flex align-items-center me-3"
          style={{
            minWidth: 'fit-content',
            flex: '0 0 auto',
          }}
        >
          <div
            className="small text-primary fw-bold me-2"
            style={{
              writingMode: 'vertical-rl',
              textOrientation: 'mixed',
              minWidth: '20px',
            }}
          >
            ONBOARDING
          </div>
          <div className="d-flex gap-2">
            <MetricCard
              label="Contract"
              value={contractVal}
              tooltip={metricDescriptions.contract}
            />
            <MetricCard
              label="Insurance"
              value={insuranceVal}
              tooltip={metricDescriptions.insurance}
            />
            <MetricCard
              label="Min Age"
              value={minAgeVal}
              tooltip={metricDescriptions.minimumAge}
            />
          </div>
        </div>

        <div
          className="align-self-stretch"
          style={{
            width: '4px',
            backgroundColor: '#ffffff',
            margin: '0 8px',
            flex: '0 0 auto',
          }}
        ></div>

        {/* WAGE SECTION */}
        <div
          className="d-flex align-items-center"
          style={{
            minWidth: 'fit-content',
            flex: '0 0 auto',
          }}
        >
          <div
            className="small text-success fw-bold me-2"
            style={{
              writingMode: 'vertical-rl',
              textOrientation: 'mixed',
              minWidth: '20px',
            }}
          >
            W&amp;P
          </div>
          <div className="d-flex gap-2">
            <MetricCard
              label={isIndicationOnly ? 'Work Hours *' : 'Work Hours'}
              value={workHoursVal}
              colorType="workingHours"
              tooltip={metricDescriptions.workHours}
            />
            <MetricCard
              label="Minimum Wage"
              value={wageAboveMinVal}
              tooltip={metricDescriptions.wageAboveMinimum}
            />
            <MetricCard
              label="Payment Logs"
              value={paymentLogsVal}
              tooltip={metricDescriptions.paymentLogs}
            />
            <MetricCard
              label={isIndicationOnly ? 'Productivity *' : 'Productivity'}
              value={productivityVal}
              tooltip={metricDescriptions.productivity}
            />
            {isCoordinator && (
              <>
                <MetricCard
                  label="Est. Hours"
                  value={getCoordinatorMetricValue(supplier.wage, 'estimatedHours')}
                  suffix="h"
                  tooltip="Perkiraan jumlah jam kerja koordinator."
                />
                <MetricCard
                  label="Hourly Wage"
                  value={getCoordinatorMetricValue(supplier.wage, 'hourlyWage')}
                  suffix=""
                  tooltip="Perkiraan upah koordinator untuk setiap jam kerja."
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SupplierMetrics
